import React from 'react';
import BookD from '../components/Contact/BookD.js';


const BookDemo = () => {
  return (
    <div>
        <BookD/>
        

    </div>
  );
};

export default BookDemo;
